import { c as _c } from "react/compiler-runtime";
import { type ButtonProps as UIButtonProps } from "../../Button";
import { cn } from "@local/utils/src/cn";
import type { Route } from "next";
import { Link } from "./Link";
export interface ButtonProps extends UIButtonProps {
  type?: "button" | "submit" | "reset";
  variant?: "default" | "primary" | "whiteOutline" | "link";
  size?: "default" | "link";
  url?: string;
}
const baseClasses = ["w-full max-w-[360px] sm:w-[340px] md:w-[360px] min-h-12 flex flex-row items-center justify-center text-center gap-2 py-6 px-16 lg:px-20 align-middle text-base md:text-lg font-medium transition-all leading-tight box-border whitespace-nowrap rounded-md", "focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-gray-700 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 cursor-pointer disabled:cursor-not-allowed"];
const variantClasses = {
  default: "bg-gray-950 text-white hover:bg-gray-800 hover:underline",
  primary: "bg-red-600 text-white hover:bg-red-700 hover:underline",
  whiteOutline: "border border-white text-white hover:bg-white hover:underline",
  link: "bg-none text-dark hover:underline"
};
const sizeClasses = {
  default: "px-4 py-2"
  // link: "px-0! py-0 min-h-max w-max!",
};
const getButtonClasses = (variant = "default", size = "default") => {
  return cn(baseClasses, variantClasses[variant as keyof typeof variantClasses], sizeClasses[size as keyof typeof sizeClasses]);
};
export const Button = t0 => {
  const $ = _c(32);
  let children;
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  let url;
  if ($[0] !== t0) {
    ({
      className,
      variant: t1,
      size: t2,
      children,
      url,
      type: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = rest;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = url;
  } else {
    children = $[1];
    className = $[2];
    rest = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    url = $[7];
  }
  const variant = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "default" : t2;
  const type = t3 === undefined ? "button" : t3;
  let t4;
  let t5;
  let t6;
  if ($[8] !== children || $[9] !== className || $[10] !== rest || $[11] !== size || $[12] !== type || $[13] !== url || $[14] !== variant) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const buttonClasses = getButtonClasses(variant, size);
      if (url && url?.length > 0) {
        const linkClasses = cn("block", buttonClasses, className);
        const isInternal = url.startsWith("/");
        const {
          "aria-hidden": ariaHidden,
          "aria-label": ariaLabel,
          "aria-labelledby": ariaLabelledBy,
          "aria-describedby": ariaDescribedBy,
          id,
          tabIndex,
          title,
          style
        } = rest;
        let t7;
        if ($[18] !== ariaDescribedBy || $[19] !== ariaHidden || $[20] !== ariaLabel || $[21] !== ariaLabelledBy || $[22] !== id || $[23] !== style || $[24] !== tabIndex || $[25] !== title) {
          t7 = {
            "aria-hidden": ariaHidden,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-describedby": ariaDescribedBy,
            id,
            tabIndex,
            title,
            style
          };
          $[18] = ariaDescribedBy;
          $[19] = ariaHidden;
          $[20] = ariaLabel;
          $[21] = ariaLabelledBy;
          $[22] = id;
          $[23] = style;
          $[24] = tabIndex;
          $[25] = title;
          $[26] = t7;
        } else {
          t7 = $[26];
        }
        const sharedAnchorProps = t7;
        if (isInternal) {
          t6 = <Link href={url as Route} className={linkClasses} prefetch={false} {...sharedAnchorProps}>{children}</Link>;
          break bb0;
        }
        t6 = <a className={linkClasses} href={url} rel="noopener noreferrer" {...sharedAnchorProps}>{children}</a>;
        break bb0;
      }
      t4 = type;
      t5 = cn(buttonClasses, className);
    }
    $[8] = children;
    $[9] = className;
    $[10] = rest;
    $[11] = size;
    $[12] = type;
    $[13] = url;
    $[14] = variant;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t4 = $[15];
    t5 = $[16];
    t6 = $[17];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[27] !== children || $[28] !== rest || $[29] !== t4 || $[30] !== t5) {
    t7 = <button type={t4} className={t5} {...rest}>{children}</button>;
    $[27] = children;
    $[28] = rest;
    $[29] = t4;
    $[30] = t5;
    $[31] = t7;
  } else {
    t7 = $[31];
  }
  return t7;
};